import { render, staticRenderFns } from "./TabletSaveModal.vue?vue&type=template&id=5d5adb2a&scoped=true&"
import script from "./TabletSaveModal.vue?vue&type=script&lang=js&"
export * from "./TabletSaveModal.vue?vue&type=script&lang=js&"
import style0 from "./TabletSaveModal.vue?vue&type=style&index=0&id=5d5adb2a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5adb2a",
  null
  
)

export default component.exports